/* eslint-disable import/no-anonymous-default-export */
export default {

  order: {
    headers: [
      'tipo',
      'documento',
      'nome',
      'cpf',
      'especialidade',
      'rua',
      'numero',
      'complemento',
      'bairro',
      'cep',
      'cidade',
      'uf',
      'telefone',
      'email',
      'sexo',
    ],
    requiredColumns: [
      'tipo',
      'documento',
      'nome',
      'rua',
      'cep',
      'cidade',
      'uf',
    ],
  },

  representatives: {
    headers: [
      'nome',
      'telefone',
      'funcao',
      'email',
      'senha',
    ],
    requiredColumns: [
      'nome',
      'funcao',
      'email',
      'senha',
    ],
  },

  sectors: {
    headers: [
      'representante',
      'id',
      'tipo_usuario',
      'documento',
      'nome',
      'cpf',
      'email',
      'telefone',
    ],
    requiredColumns: [
      'representante',
      'id',
      'tipo_usuario',
      'documento',
      'nome',
      'cpf',
    ],
  },

  'sectors-gd': {
    headers: [
      'representante',
      'id',
      'setor',
    ],
    requiredColumns: [
      'representante',
      'id',
      'setor',
    ],
  },

  kitImport:{
    headers:[
      'contrato_flash',
      'flash_id',
      'codigo_da_amostra',
      'quantidade'
    ],
    requiredColumns:[
      'contrato_flash',
      'flash_id',
      'codigo_da_amostra',
      'quantidade'
    ]
  },

  panels:{
    headers:[
      'tipo',
      'documento',
      'nome',
      'cpf',
      'especialidade',
      'rua',
      'numero',
      'complemento',
      'bairro',
      'cep',
      'cidade',
      'uf',
      'telefone',
      'email',
      'sexo',
    ],
    requiredColumns:[
      'tipo',
      'documento',
      'nome',
      'rua',
      'cep',
      'cidade',
      'uf',
    ]
  },

  'consolidated-delivered-orders': {
    headers: [
      'notafiscal',
      'descricao',
      'lote',
      'datafabricacao',
      'datavencimento',
      'qtd.item',
      'numerodocumentosap',
      'notafiscaldeentrega',
      'chavedanfe',
      'nomedomedico',
      'crm',
      'datadepostagem',
      'status',
      'datadebaixa',
    ],
    requiredColumns: [
      'crm',
      'nomedomedico',
      'descricao',
      'lote',
      'qtd.item',
      'datadebaixa',
      'datafabricacao',
      'datadepostagem',
      'notafiscal',
    ],
  },
};
